import { render } from "./PlantDetail.vue?vue&type=template&id=5c0d4cf8&ts=true"
import script from "./PlantDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlantDetail.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/plant/PlantDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c0d4cf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c0d4cf8', __exports__)) {
    api.reload('5c0d4cf8', __exports__)
  }
  
  module.hot.accept("./PlantDetail.vue?vue&type=template&id=5c0d4cf8&ts=true", () => {
    api.rerender('5c0d4cf8', render)
  })

}


export default __exports__